import { useRef, useEffect } from 'react';

export function useOnSelectionChange({
    container = document,
    callback
}: {
    container?: Element | Document | null;
    callback: (selectedText: string) => void;
}) {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        if (!container) {
            return;
        }
        function handler(e: MouseEvent | KeyboardEvent) {
            if (e.shiftKey) {
                return;
            }
            setTimeout(() => {
                const selection = window.getSelection();
                if (selection.type === 'Range') {
                    callbackRef.current(selection.toString());
                }
            });
        }
        container.addEventListener('mouseup', handler);
        container.addEventListener('keyup', handler);

        return () => {
            container.removeEventListener('mouseup', handler);
            container.removeEventListener('keyup', handler);
        };
    }, [container]);
}
